/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Import_Status_Creating_ProjectInputs */



/**
* | output |
* | --- |
* | "Creating project..." |
*
* @param {Work_Order_Import_Status_Creating_ProjectInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_import_status_creating_project = /** @type {((inputs?: Work_Order_Import_Status_Creating_ProjectInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Import_Status_Creating_ProjectInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Création du projet...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Projekt wird erstellt...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creazione del progetto...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создание проекта...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Creando proyecto...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建项目...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトを作成しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रोजेक्ट तैयार हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criando projeto...")
	return /** @type {LocalizedString} */ ("Creating project...")
});